import { debug } from './debug';

export const handleError = closure => (...args) => {
  try {
    return closure(...args);
  } catch (error) {
    debug.error(error);
  }
};
